module.exports = __webpack_public_path__ + "static/media/ps.b4da038d.wasm";